import Moment from "moment";
import {
  addEvents,
  deleteEvent,
  editEvent,
} from "../features/personalDatabaseSlice";

import { generateEventId } from "../utils/data/events";

export const birthdayEventTask = function (store) {
  const state = store.getState();

  if (!state.personalDatabase.contents) {
    console.log("Database not ready");
    return;
  }
  const events = state.personalDatabase.contents.events;
  const dob = state.personalDatabase.contents.metadata.dateOfBirth;
  const dobMom = Moment(dob);

  console.log("tick tock", state);

  const startYear = Moment(dob).year();
  const endYear =
    events.length > 0
      ? Moment(events[events.length - 1].datetime).year()
      : Moment().year();

  // run through all years

  if (startYear > endYear) {
    throw new Error("Invalid start/end year combination");
  }

  const yearsWithBdayEvents = [];

  const toDeleteIds = [];
  events.forEach((event) => {
    // only process bday events
    if (event.eventType !== "EventGeneralBirthday") {
      return;
    }
    // check if the year is correct

    const eventDatetime = Moment(event.datetime);
    const eventYear = eventDatetime.year();

    if (yearsWithBdayEvents.includes(eventYear)) {
      // we should not be seeing bday event twice - delete
      toDeleteIds.push(event.id);
    } else {
      yearsWithBdayEvents.push(eventYear);

      // check if we need to update bday event date, is it correct?
      if (
        eventDatetime.month() != dobMom.month() ||
        eventDatetime.date() != eventDatetime.date()
      ) {
        eventDatetime.month(dobMom.month());
        eventDatetime.date(dobMom.date());
        console.log(
          "Bday event date not correct - editing...",
          eventDatetime.toISOString()
        );

        const updatedEvent = {
          ...event,
          description: `You have just turned ${eventYear - dobMom.year()}`,
          datetime: eventDatetime.toISOString(),
        };
        //console.log(updatedEvent);
        store.dispatch(
          editEvent({
            item: updatedEvent,
          })
        );
      }
    }
  });

  // delete duplicate bday events
  toDeleteIds.forEach((toDeleteId) => {
    store.dispatch(
      deleteEvent({
        id: toDeleteId,
      })
    );
  });

  const toAddEvents = [];
  // now, populate any missing bdays!
  for (var year = startYear; year <= endYear; year++) {
    if (yearsWithBdayEvents.includes(year)) {
      continue;
    }
    const yearBdate = Moment(dob); // created off dob
    yearBdate.year(year);
    const birthdayEvent = {
      name: "Happy Birthday!",
      description: `You have just turned ${year - dobMom.year()}`,
      displayTimezone: "",
      categoryId: 0, // zero for auto-generated events
      datetime: yearBdate.toISOString(),
      datetimeEnd: "",
      attachments: [],
      tags: [],
    };

    birthdayEvent.id = generateEventId(birthdayEvent);
    //console.log(birthdayEvent);

    toAddEvents.push({
      eventType: "EventGeneralBirthday",
      item: birthdayEvent,
    });
  }

  if (toAddEvents.length > 0) {
    store.dispatch(
      addEvents({
        itemsAndTypes: toAddEvents,
      })
    );
  }
};
